import RoutesPage from "../routes";

export default function WishlistRoutesPage() {
    return <RoutesPage initialFilter="wishlist" />;
}
